import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { to: '/templates', label: 'Templates' },
  { to: '/agents', label: 'Agents' },
  { to: '/knowledge', label: 'Knowledge' },
  { to: '/chat', label: 'Chat' },
  { to: '/compare', label: 'Compare' },
  { to: '/api-docs', label: 'API Docs' },
];

const adminItems = [
  { to: '/admin/workspaces', label: 'Workspaces' },
  { to: '/admin/dialogs', label: 'Dialogs' },
  { to: '/admin/users', label: 'Users' },
];

export function Layout() {
  const { isAuthenticated, logout } = useAuth();

  return (
    <div style={s.wrapper}>
      <aside style={s.sidebar}>
        <h1 style={s.logo}>Eazyshow Live Agent</h1>

        <nav style={s.nav}>
          {navItems.map(({ to, label }) => (
            <NavLink key={to} to={to} style={({ isActive }) => ({ ...s.link, ...(isActive ? s.linkActive : {}) })}>
              {label}
            </NavLink>
          ))}
        </nav>

        <div style={s.divider} />
        <span style={s.sectionLabel}>Admin</span>
        <nav style={s.nav}>
          {isAuthenticated ? (
            <>
              {adminItems.map(({ to, label }) => (
                <NavLink key={to} to={to} style={({ isActive }) => ({ ...s.link, ...(isActive ? s.linkActive : {}) })}>
                  {label}
                </NavLink>
              ))}
            </>
          ) : (
            <NavLink to="/login" style={({ isActive }) => ({ ...s.link, ...(isActive ? s.linkActive : {}) })}>
              Sign In
            </NavLink>
          )}
        </nav>

        <div style={{ flex: 1 }} />
        {process.env.REACT_APP_VERSION && (
          <span style={s.version}>v.{process.env.REACT_APP_VERSION}</span>
        )}
        {isAuthenticated && (
          <button style={s.logoutBtn} onClick={logout}>Sign Out</button>
        )}
      </aside>

      <main style={s.main}>
        <Outlet />
      </main>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  wrapper: {
    display: 'flex',
    height: '100vh',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  sidebar: {
    width: 200,
    minWidth: 200,
    background: '#1a1a2e',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 0',
  },
  logo: {
    margin: '0 0 24px',
    padding: '0 16px',
    fontSize: 16,
    fontWeight: 700,
    color: '#fff',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  link: {
    padding: '8px 16px',
    fontSize: 13,
    color: '#a0a0b8',
    textDecoration: 'none',
    borderLeft: '3px solid transparent',
    transition: 'all 0.15s',
  },
  linkActive: {
    color: '#fff',
    background: 'rgba(255,255,255,0.08)',
    borderLeftColor: '#4f46e5',
  },
  divider: {
    height: 1,
    background: 'rgba(255,255,255,0.1)',
    margin: '16px 16px',
  },
  sectionLabel: {
    padding: '0 16px 6px',
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase' as const,
    letterSpacing: 1,
    color: '#666',
  },
  main: {
    flex: 1,
    overflowY: 'auto',
    background: '#fff',
  },
  version: {
    padding: '0 16px 8px',
    fontSize: 10,
    color: '#555',
    fontFamily: 'monospace',
  },
  logoutBtn: {
    margin: '8px 16px 12px',
    padding: '6px 12px',
    borderRadius: 6,
    border: '1px solid rgba(255,255,255,0.15)',
    background: 'transparent',
    color: '#a0a0b8',
    fontSize: 12,
    cursor: 'pointer',
  },
};
